// extracted by mini-css-extract-plugin
export default {"menuButton":"t4ZTqUpyvdDGyw1r8Z5n","arrow":"MKOHM8ZDUlrPi7dDa8wr","buttonIcon":"vlN9SmR95ISE11b5NkMd","primary":"xwXIpM4kEwjZG8PV87PI","outline":"tHXxKr79EcwmHdaEzId2"};